import React, { Component } from 'react';
import ReactDOM from 'react-dom'

import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import { dateDataTimeFormatter,dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import  PanelLayout  from "../layout/panel-layout";
import { enumMessageState } from '../../constants/enum.constants';

class CustomSearchField extends React.Component {
    // It's necessary to implement getValue
    getValue() {
      return ReactDOM.findDOMNode(this).value;
    }
  
    // It's necessary to implement setValue
    setValue(value) {
      ReactDOM.findDOMNode(this).value = value;
    }
  
    render() {
      return (
        <input
          className={ `form-control` }
          type='text'
          defaultValue={ '' }
          placeholder={ 'جستجو' }
          onKeyUp={ this.props.search }/>
      );
    }
  }
  function buttonFormatter(cell, row,extra) {
    return (
      <div>
          <Link to={`/message/show/${cell}`} className="btn btn-default btn-sm"><i className="fa fa-eye"></i> نمایش </Link>
          &nbsp;&nbsp;
          <button className="btn btn-default btn-sm" onClick={()=>extra.props.deleteHandler(cell)}><i className="fa fa-trash"></i> حذف </button>
      </div>
    );
  }
  function cityFormatter(cell, row) {
    return cell!=null ? cell.Title:'';
  }
    


class MessageList extends React.Component {
    
    constructor(props) {
        super(props);
       
        this.state = {
        
          sizePerPage: 10,
          currentPage: 1,
          sortField :'datecreated',
          sortOrder:'desc',
          searchText:''
        };

        this.onPageChange=this.onPageChange.bind(this);
        this.onSizePerPageList=this.onSizePerPageList.bind(this);
        this.onSortChange=this.onSortChange.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
      }
    
      onPageChange(page, sizePerPage) {
        const {sortField,sortOrder,searchText} = this.state;
        this.props.remoteDataHandler(page,sizePerPage,sortField,sortOrder,searchText);
        this.setState({
        
          currentPage: page,
          sizePerPage: sizePerPage
        });
      }
    
      onSizePerPageList(sizePerPage) {
        const {currentPage}  =this.state;
        const {sortField,sortOrder,searchText} = this.state;
       
        this.props.remoteDataHandler(currentPage,sizePerPage,sortField,sortOrder,searchText);
        this.setState({
          
          sizePerPage: sizePerPage
        });
      }
      onSortChange(sortName, sortOrder) {
        console.log(sortOrder);
        const {currentPage,sizePerPage,searchText}=this.state;
        this.props.remoteDataHandler(currentPage,sizePerPage,sortName,sortOrder,searchText);


    
        this.setState({
            sortField: sortName,
            sortOrder: sortOrder
        });
      }

      onSearchChange(searchText, colInfos, multiColumnSearch) {
        const {currentPage,sizePerPage,sortField,sortOrder}=this.state;
       

        const text = searchText.trim();
        if (text === '') {
          this.props.remoteDataHandler(currentPage,sizePerPage,sortField,sortOrder,'');  
          this.setState({
            searchText: searchText
          });
          return;
        }else{
            
            this.props.remoteDataHandler(1,sizePerPage,sortField,sortOrder,searchText);  
            this.setState({
              searchText: searchText
            });
            return; 
        }
    
      }
      
    

    

    render() { 
      const {list}=this.props;
      console.log('TABLE',list)
        return ( 
            <div>
                <PanelLayout title={this.props.isInbox?'پیام های دریافتی':'پیام های ارسالی'}>
                
                    <div className="panel-body custom">
                        <div className="panel panel-default">
                            <div className="toolbox">

                                <Link to="/message/new" className="btn btn-default btn-sm" onClick={this.handleClick} ><i className="fa fa-envelope"></i>  پیام جدید </Link>

                            </div>
                        </div>
                       
                            <BootstrapTable data={list && list.Queryable}  striped hover
                                headerContainerClass='rightAlignStyle'
                                bodyContainerClass='rightAlignStyle'
                                remote={ true } pagination={ true } search={ true }
                                fetchInfo={ { dataTotalSize: (list!=null? list.RowCount:0) } }
                                options={ { sizePerPage: this.state.sizePerPage,
                                    onPageChange: this.onPageChange,
                                    sizePerPageList: [ 5, 10,20,30,50 ],
                                    page: (list!=null? list.CurrentPage:1),
                                    onSizePerPageList: this.onSizePerPageList,
                                    onSortChange: this.onSortChange,
                                    onSearchChange: this.onSearchChange,
                                searchField: (props) => (<CustomSearchField { ...props }  />)
                                 } }   
                            >
                                <TableHeaderColumn isKey dataField='Id' hidden >id</TableHeaderColumn>
                                <TableHeaderColumn dataField='Title' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>عنوان</TableHeaderColumn>
                                <TableHeaderColumn dataField='FromUser' formatExtraData="FullName" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }>فرستنده</TableHeaderColumn>
                                <TableHeaderColumn dataField='ToUser' formatExtraData="FullName" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }>گیرنده</TableHeaderColumn>
                                <TableHeaderColumn dataField='SendDate' dataSort={ true } thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ dateDataTimeFormatter }>تاریخ</TableHeaderColumn>
                                <TableHeaderColumn dataField='MessageState' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ enumDataFormatter } formatExtraData={ enumMessageState} >وضعیت</TableHeaderColumn>
                                <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter } formatExtraData={this}></TableHeaderColumn>
                            </BootstrapTable>

                        
                    </div>    
                   
                </PanelLayout>
               
                
                
            </div>
        
        );
    }
}

 
export default MessageList;